import axios from '@/services/axios'

export interface LogEntry {
	timestamp: string
	message: string
	data?: any
}

export interface UploadPayload {
	fileName: string
	logs: LogEntry[]
}

export interface LogFileSummary {
	name: string
	sizeKB: string
	modifiedAt: string
}

const uploadBookingLog = async (payload: UploadPayload) => {
	const response = await axios.post('/logs/booking', payload)
	return response.data
}

const getLogFile = async (fileName: string): Promise<string> => {
	const response = await axios.get(`/logs/${encodeURIComponent(fileName)}`, {
		responseType: 'text',
	})
	return response.data
}

const listLogs = async (): Promise<{
	success: boolean
	total: number
	files: LogFileSummary[]
}> => {
	const response = await axios.get('/logs')
	return response.data
}

const logService = {
	uploadBookingLog,
	getLogFile,
	listLogs,
}

export default logService
